module.exports = __webpack_public_path__ + "static/SFMono-RegularItalic-8eddf7adea62d66b9e4d031b58dfaaa6.ttf";